var $a9a6dc20ff9e364d$exports = {};
$a9a6dc20ff9e364d$exports = {
    "breadcrumbs": `\u{5BFC}\u{822A}\u{680F}`
};


export {$a9a6dc20ff9e364d$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
